import * as types from '@/store/mutation-types'

const state = {
  apis: {},
  environment: '',
  googleMapsApiKey: '',
  loginUrl: '',
  accountToken: '',
  appId: '',
  appSecret: '',
  userToken: ''
}

export const getters = {
  apis: state => {
    return state.apis
  },
  environment: state => {
    return state.environment
  },
  loginUrl: state => {
    return state.loginUrl
  },
  appId: state => {
    return state.appId
  },
  appSecret: state => {
    return state.appSecret
  },
  userToken: state => {
    return state.userToken
  },
  accountToken: state => {
    return state.accountToken
  }
}

export const actions = {
  setLoginUrl ({ commit }, loginUrl) {
    commit(types.SET_LOGIN_URL, loginUrl)
  },
  setAppId ({ commit }, appId) {
    commit(types.SET_APP_ID, appId)
  },
  setAppSecret ({ commit }, appSecret) {
    commit(types.SET_APP_SECRET, appSecret)
  },
  setUserToken ({ commit }, userToken) {
    commit(types.SET_USER_TOKEN, userToken)
  },
  setAccountToken ({ commit }, accountToken) {
    commit(types.SET_ACCOUNT_TOKEN, accountToken)
  }
}

export const mutations = {
  [types.SET_ACCOUNT_TOKEN] (state, accountToken) {
    state.accountToken = accountToken
  },
  [types.SET_APIS] (state, apis) {
    state.apis = apis
  },
  [types.SET_APP_ID] (state, appId) {
    state.appId = appId
  },
  [types.SET_APP_SECRET] (state, appSecret) {
    state.appSecret = appSecret
  },
  [types.SET_ENVIRONMENT] (state, environment) {
    state.environment = environment
  },
  [types.SET_GOOGLE_MAPS_API_KEY] (state, key) {
    state.googleMapsApiKey = key
  },
  [types.SET_LOGIN_URL] (state, loginUrl) {
    state.loginUrl = loginUrl
  },
  [types.SET_USER_TOKEN] (state, userToken) {
    state.userToken = userToken
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
